import React from 'react'
import './styles.scss'
import { message } from 'antd'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import 'react-block-ui/style.css'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import Header  from './header'
import Files   from './files'

class EncodingStatus extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      files:[],
      heartbeat:1000
    }
  }

  componentDidMount() {
    this.heartbeat(0)
  }

  componentWillUnmount(){
    this.heartbeat = ()=> console.log('empty heartbeat')
  }

  on_cancel = job => {
    CloudFlyerAPI.encoding
      .cancel(job.id)
      .then(res=>{
        message.success('Cancelled successfully')
      })
      .catch(err=>{
        message.error(err.message)
      })
  }

  heartbeat = timeout => {
    let $this = this

    setTimeout(()=> {
      CloudFlyerAPI.encoding
        .jobs()
        .then(res=> {
          if(!((res||{}).data||{})){
            return $this.heartbeat()
          }

          let MAX_FINISHED_JOBS  = 20,
            finishedCounter= 0,
            isCurrentProgressSet = false

          let files = ((res||{}).data||{}).reverse()
            .filter(job => {
              if (!job.finished) {
                return job
              }

              if (finishedCounter < MAX_FINISHED_JOBS) {
                finishedCounter++;
                return job;
              }
            })

          let new_files = []
          files.forEach(f=>{
            if (!$this.state.files.some(x=> x.id === f.id)) {
              new_files.push(f)
            }
          })

          files = new_files.concat($this.state.files)
          $this.setState({files})

          let unFinishedJobs = files
            .filter(job=> {
              if (job.finished) {
                job.progress = "100.0";
                job.time_left = "0";
              }

              return !job.status || job.status === 'Processing' || job.status === 'New' //!job.finished;
            })
            .map(job=> {
              if (!isCurrentProgressSet) {
                job.currentProgress = true;
                isCurrentProgressSet = true;
              }

              return CloudFlyerAPI.encoding.status(job.id)
            })

          Promise.all(unFinishedJobs)
            .then(results => {
              results
                .map(({data})=> {
                  files.map(job=> {
                      if (job.id === data.id) {
                        console.log(data.status, data.progress)

                        job.progress  = data.progress
                        job.time_left = data.time_left
                        job.finished  = data.finished
                        job.status    = data.status
                        job.error     = data.error
                      }
                    })
                  $this.setState({files})
                })
              $this.heartbeat()
            })
            .catch(e =>{
              console.info('Jobs: error')
              console.error(e)
              $this.heartbeat()
            })
        })
        .catch(e =>{
          console.info('Jobs: error')
          console.error(e)
          $this.heartbeat()
        })
    }, timeout ? timeout : $this.state.heartbeat);
  }

  render(){
    const {files} = this.state

    return (
      <div className='files-encoding'>

        <Header title={'Encoding Status'}
                disabled  = {true}
                on_cancel = {this.on_cancel.bind(this)}/>

        <hr/>

        <Files
          key                       = {'Files'}
          files                     = {files}
          on_cancel                 = {this.on_cancel.bind(this)}
          on_click                  = {this.heartbeat.bind(this)}
        />
      </div>
    )
  }
}

export default withRouter(connect(
  ({}) => {
    return {}
  }, (dispatch) => bindActionCreators({

  }, dispatch))(EncodingStatus))
